import React from 'react'
import GroupItemsList from '../GroupItemsList'


const items = [
    {
        title : 'EIA',
        icon : 'earth',
        items : [
            { name : 'Estudios Impacto Ambiental', link : '/estudios-impacto-ambiental' },
            { name : 'Mitigaciones Ambientales', link : '/mitigaciones-ambientales' },
        ]
    }
]


const EDAsList = (props) => (
    <GroupItemsList title={"Estudios Impacto Ambiental"} groupItems={items}/>
)

export default EDAsList